var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import omit from 'lodash/omit';
import * as React from 'react';
import { StyledLabel } from './style';
var ExtendLabel = /** @class */ (function (_super) {
    __extends(ExtendLabel, _super);
    function ExtendLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExtendLabel.prototype.render = function () {
        var props = omit(this.props, [
            'role',
            'status',
            'schedule',
            'customColor',
        ]);
        return React.createElement(StyledLabel, __assign({}, props));
    };
    return ExtendLabel;
}(React.Component));
export default ExtendLabel;
//# sourceMappingURL=label.js.map